import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAccessToken } from "@shared/api/getAccessToken";
import { API } from "../authSlice";

export const confirmEmailCode = createAsyncThunk<any, any, { rejectValue: { message: string } }>(
    "auth/confirmEmailCode",
    async (payload: any, thunkAPI) => {
        const TOKEN = getAccessToken();
        try {
            const response = await fetch(`${API}/v1/verification/email/second_step`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Auth-token": TOKEN
                },
                body: JSON.stringify(payload)
            });

            let data = await response.json();

            return data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ message: error.message });
        }
    }
);